import { Colors } from "../constants/colors";

export default {
  variants: [
    {
      props: { variant: "gridUrlRender" },
      style: {
        textDecoration: "none",
        color: Colors.BLUE500,
      },
    },
    {
      props: { variant: "blue" },
      style: {
        color: Colors.BLUE300,
        textDecoration: "underline",
        cursor: "pointer",
        "&:hover": {
          color: Colors.BLUE500,
        },
        "&:focus": {
          color: Colors.BLUE500,
        },
      },
    },
  ],
};
